import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Checkbox } from 'antd'
import QRCode from 'qrcode.react'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

const Index = () => {

    const QRColor = {
        black: '#000000',
        white: '#FFFFFF'
    }

    const [generatedUUID, setGeneratedUUID] = useState(null)
    const [qrcolor, setQRColor] = useState(QRColor.black)

    const handleDownload = (e) => {
		e.preventDefault()

		const generatedQRFilename = `${generatedUUID}_${moment().format('YYYYMMDDHHmmss')}`
		const canvas = document.getElementById('generated-qr')
		const pngUrl = canvas
			.toDataURL('image/png')
			.replace('image/png', 'image/octet-stream')
		let downloadLink = document.createElement('a')
		downloadLink.href = pngUrl
		downloadLink.download = `${generatedQRFilename}.png`
		document.body.appendChild(downloadLink)
		downloadLink.click()
		document.body.removeChild(downloadLink)
	}

    const generateNewUUID = () => {
        const newUID = uuidv4();
        setGeneratedUUID(newUID);
    }

    useEffect(() => {
        generateNewUUID();
    }, []);

    return (
        <Row style={{ textAlign: 'center' }}>
            <Col md={24} sm={24}>
                <Row justify='center' style={{ display: 'block' }}>
                    <div>
                        <Checkbox onChange={() => {
                            if (_.isEqual(qrcolor, QRColor.black)) {
                                setQRColor(QRColor.white)
                            } else {
                                setQRColor(QRColor.black)
                            }
                        }}>
                            {
                                _.isEqual(qrcolor, QRColor.black) ? 'Check to set White QR Code' : 'Uncheck to set Black QR Code'
                            }
                        </Checkbox>
                    </div>
                    <div className='qr-code'>
                        <QRCode 
                            id='generated-qr' 
                            value={generatedUUID}
                            size={350}
                            level={'H'}
                            includeMargin={true}
                            bgColor={_.isEqual(qrcolor, QRColor.black) ? QRColor.white : QRColor.black}
                            fgColor={_.isEqual(qrcolor, QRColor.black) ? QRColor.black : QRColor.white}
                        />
                    </div>
                    <label style={{ marginTop: 20, fontSize: 27, fontWeight: 'bold' }}>{generatedUUID}</label>
                    <br/>
                    <small><i>GENERATED UUID</i></small>
                </Row>
            </Col>
            
            <div
                style={{
                    // position: 'absolute',
                    // right: 0,
                    // bottom: 10,
                    marginTop: 50,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'center',
                }}
            >
                <Row gutter={16} justify='center'>
                    <Col md={12} sm={24}>
                        <Button size='large' type='ghost' onClick={() => generateNewUUID()}>Generate New QR Code UUID</Button>
                    </Col>
                    <Col md={12} sm={24}>
                        <Button size='large' type='primary' onClick={(e) => handleDownload(e)}>Download QR Code</Button>
                    </Col>
                </Row>
            </div>
        </Row>
    )
}

export default Index